import axios, { AxiosResponse } from 'axios';

export enum EStavZadosti {
    SOUHL = 'SOUHL',
    OBJED = 'OBJED',
    PLZAPL = 'PLZAPL',
    BIPOSK = 'BIPOSK',
    UCDAL = 'UCDAL',
    CEKA = 'CEKA',
    ZPRAC = 'ZPRAC',
    PLZRUS = 'PLZRUS',
    PLNEZAPL = 'PLNEZAPL',
    BINEPO = 'BINEPO',
    REFUND = 'REFUND'
}

export interface IStavResp {
    stav: EStavZadosti;
    token: string;
}

export const nzStavApi = (id: string) => {
    return axios({
        method: 'GET',
        url: '/ZU/stav',
        params: {
            idzadosti: id
        }
    }).then((resp: AxiosResponse<IStavResp>) => resp.data);
};

export interface IZadostResp {
    zadostid?: string;
    stav?: EStavZadosti;
    email?: string;
    telefon?: string;
    zmenosudaj?: boolean;
    zmenbankuc?: boolean;
    rcma?: string;
    rodnecislo?: string;
    cena?: number;
    platnostOd?: string;
    platnostDo?: string;
    jmeno?: string;
    prijmeni?: string;
    ulice?: string;
    mesto?: string;
    psc?: string;
    stat?: string;
    bankucty?: {
        idbankucet?: number;
        pred?: string;
        ciuc?: string;
        kcca?: string;
        bice?: string;
        nzuc?: string;
        iban?: string;
    }[];
}

export const nzZadostApi = (token: string) => {
    return axios({
        method: 'GET',
        url: '/ZU/zadost',
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then((resp: AxiosResponse<IZadostResp>) => resp.data);
};

export const nzdownloadPDF = (fileType: 'pdf' | 'xml' | 'zip' | 'html', token: String, typ: 'protokol' | 'faktura') =>
    // fileName?: string
    {
        return axios({
            method: 'GET',
            url: '/ZU/zadost/DownloadPDF',
            params: {
                typ: typ
            },
            headers: {
                Authorization: `Bearer ${token}`
            },
            responseType: 'blob' // important
        }).then(resp => {
            if (resp.status === 200) {
                let fileName = '';

                if (typ === 'protokol') {
                    fileName = 'Protokol';
                } else if (typ === 'faktura') {
                    fileName = 'Faktura';
                } // TODO: Predelat na nejakej lepsi zpusob... rn nevim jak to s tim typem bude :D

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // IE
                    window.navigator.msSaveOrOpenBlob(resp.data, fileName);
                } else {
                    const odp = resp.data;
                    const uriContent = URL.createObjectURL(
                        new Blob([odp], {
                            type: `application/${fileType}`
                        })
                    );
                    const link = document.createElement('a');
                    link.style.display = 'none';
                    // link.download = fileName || 'Výpis z nezařazeného účtu';
                    link.download = fileName || 'pdf';
                    link.href = uriContent;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        });
    };
export const nzSouhlasApi = (data: { email: string; telefon: string }, token?: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/souhlas',
        data: data,
        ...(token && {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
    });
};

export const nzObjednatApi = (data: { zmenosudaj: boolean; zmenbankuc: boolean }, token: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/objednat',
        data: data,
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export interface IBankIDData {
    urlbankid: string;
    code?: number;
    message?: string;
}

export const nzPlatbaApi = (idzadosti: string, token: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/platba',
        data: {
            idzadosti
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then((resp: AxiosResponse<IBankIDData>) => resp.data);
};

export const nzBankidApi = (idzadosti?: string, token?: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/bankid',
        data: {
            idzadosti
        },
        ...(token && {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
    }).then((resp: AxiosResponse<IBankIDData>) => resp.data);
};

export interface IPlatbaInput {
    merchant?: string;
    test?: string;
    price?: string;
    curr?: string;
    label?: string;
    refId?: string;
    method?: string;
    email?: string;
    phone?: string;
    transId?: string;
    secret?: string;
    status?: string;
}

export const nzPlatbaCBApi = (data: IPlatbaInput, token: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/platbacallback',
        data: data,
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export interface IBankIDcallback {
    code?: string;
    state?: string;
    error?: string;
}

export const nzBankidCBApi = (data: IBankIDcallback, token: string) => {
    return axios({
        method: 'GET',
        url: '/ZU/bankidcallback',
        data: data,
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export interface INZucetResp {
    existuje: boolean;
}

export const nzUcet = (ucet: string, token: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/ucet',
        data: {
            ucet: ucet
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then((resp: AxiosResponse<INZucetResp>) => resp.data);
};

export const nzDokoncit = (idbankucet: number, token: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/dokoncit',
        data: {
            idbankucet: idbankucet
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export const nzKorespPlatbaApi = (idzadosti: string) => {
    return axios({
        method: 'POST',
        url: '/ZU/platbakor',
        data: {
            idzadosti: idzadosti
        }
    }).then((resp: AxiosResponse<IBankIDData>) => resp.data);
};

export interface IStavKorResp {
    zaplaceno: boolean;
    zmenosudaj: boolean;
    zmenbankuc: boolean;
    cena: number;
    platnostdo: string;
}

export const nzKorepsStavApi = (idzadosti: string) => {
    return axios({
        method: 'GET',
        url: '/ZU/stavkor',
        params: {
            idzadosti: idzadosti
        }
    }).then((resp: AxiosResponse<IStavKorResp>) => resp.data);
};
